import React, { ReactNode, Suspense } from "react";
import { SxProps } from "@mui/material";
import { TimeZone } from "types";
import { TIME_ZONES } from "utils/constants";
import { Await } from "react-router";
import FormFieldSkeleton from "components/skeletons/FormField";
import AuturaDropdown from "./AuturaDropdown";

export interface TimeZoneSelectProps {
  name: string;
  inputLabel: string;
  sx?: SxProps;
  variant?: "standard" | "outlined" | "filled";
  disabled?: boolean;
  fullWidth?: boolean;
  readonly?: boolean;
  value?: TimeZone;
  required?: boolean;
  margin?: "none" | "dense" | "normal";
  setValue: (timeZone: TimeZone) => void;
  initialValue?: string;
  resolve?: Promise<any>;
}

const TimeZoneSelect = ({
  name,
  disabled,
  sx,
  variant = "outlined",
  inputLabel,
  readonly,
  value,
  required,
  setValue,
  fullWidth = false,
  margin = "none",
  initialValue,
  resolve,
}: TimeZoneSelectProps): ReactNode => {
  // Derived from the prop, not copied into state: callers set value after
  // their data loads, and a state copy would keep showing the first render's value.
  const labelValue = value?.label.replace(/_/g, " ") || "";

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const timeZone = TIME_ZONES.find(
      (timeZone: TimeZone) =>
        timeZone.label.replace(/_/g, " ") === event.target.value,
    );
    if (timeZone) {
      setValue(timeZone);
    }
  };

  return (
    <Suspense
      fallback={
        <FormFieldSkeleton
          initialValue={initialValue}
          label={inputLabel}
          variant={variant}
          margin={margin}
          required={required}
        />
      }
    >
      <Await resolve={resolve}>
        <AuturaDropdown
          name={name}
          label={inputLabel}
          value={labelValue}
          variant={variant}
          sx={sx}
          required={required}
          fullWidth={fullWidth}
          setValue={handleChange}
          disabled={disabled}
          readonly={readonly}
          margin={margin}
          options={TIME_ZONES.map((timeZone: TimeZone) =>
            timeZone.label.replace(/_/g, " "),
          )}
        />
      </Await>
    </Suspense>
  );
};

export default TimeZoneSelect;
